import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/main/Main.vue'),
    meta: {
      title: 'Flash-Nand信息查询'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/filter',
    name: 'filter',
    component: () => import( '@/views/FlashFilter.vue')
  },

  {
    path: '/ddrInfo',
    name: 'ddr',
    component: () => import( '@/views/DramInfoView.vue')
  },
  {
    path: '/userLogin',
    name: 'login',
    component: () => import( '@/views/user/login.vue'),
    meta: {
      title: '用户 - 登录/注册'
    }
  },
  {
    path: '/userRegister',
    name: 'register',
    component: () => import( '@/views/user/register.vue'),
    meta: {
      title: '用户 - 登录/注册'
    }
  },
  {
    path: '/down/:brand/:process/:core/',
    name: 'test',
    component: () => import( '@/views/filePage/DownloadFile.vue'),
    meta: {
      title: '测试'
    }
  },


  {
    path: '/MPTools',
    name: '固件下载',
    component: () => import( '@/views/filePage/MPToolsView.vue'),
    meta: {
      title: 'Microce - 量产工具下载'
    }
  },

  {
    path: '/PDFViewer',
    name: '芯片资料',
    component: () => import( '@/views/OperatorPDF.vue'),
    meta: {
      title: 'Microce - 芯片资料'
    }
  },

    {
    path: '/Manage',
    name: '后台管理',
    component: () => import( '@/views/manage/AdminLayout.vue'),
    meta: {
      title: '数据管理'
    }
  },

  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
